import styles from './DiscardFormDialog.module.scss';
import { useTranslation } from 'react-i18next';
import {
  VdsButton,
  VdsDialog,
  VdsDialogActionFooter,
  VdsDialogBody,
  VdsDialogHeader,
  VdsDialogModal,
} from '@volt/volt-extended-components-react';
import { ReactElement, Ref } from 'react';
import { ModelName } from '@casops/store/api';

interface DiscardFormDialogProps {
  modelName: ModelName;
  elementRef: Ref<HTMLVdsDialogElement>;
  onDiscard: () => void;
}

export default function DiscardFormDialog({
  elementRef,
  modelName,
  onDiscard,
}: DiscardFormDialogProps): ReactElement {
  const { t } = useTranslation();

  return (
    <VdsDialog
      ref={elementRef}
      key="form-navigation"
      padding="spacing-07"
      backdrop={true}
      width="650px"
      className={styles.removeFootprint}
    >
      <VdsDialogModal>
        <VdsDialogHeader slot="header" show-close-button={false}>
          {t('Model.Discard.Title', { modelName })}
        </VdsDialogHeader>

        <VdsDialogBody slot="body" className={styles.body}>
          <p className={styles.content}>{t('Model.Discard.Body', { modelName })}</p>
        </VdsDialogBody>

        <VdsDialogActionFooter slot="footer" class="vds__dialog__footer--end">
          <VdsButton variant="tertiary" onClick={onDiscard} style={{ width: 150 }} isFullWidth>
            {t('DiscardChanges')}
          </VdsButton>
          <VdsButton variant="primary" close-dialog="" style={{ width: 150 }} isFullWidth>
            {t('KeepEditing')}
          </VdsButton>
        </VdsDialogActionFooter>
      </VdsDialogModal>
    </VdsDialog>
  );
}
